import { PROJECTNAMEFA } from "config/info";
import Link from "next/link";
import { useEffect } from "react";

interface IBreadCrumpItems {
  title: string;
  href?: string;
}

export interface IBreadCrump {
  data: Array<IBreadCrumpItems>;
}

const CustomBreadCrump = ({ data }: IBreadCrump) => {
  useEffect(() => {
    let temp = `${PROJECTNAMEFA}  |  ${data[data.length - 1].title}`;

    document.title = temp;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <nav className="breadcrumb " aria-label="breadcrumbs">
      <ul className="flex items-center">
        {data.map((el, i) => {
          return i !== data.length - 1 ? (
            <li key={i} className="flex items-center">
              <Link
                prefetch={false}
                href={el.href || ""}
                passHref
                className="text-12 text-gray-7C7C7C me-1">
                {el.title + " /"}
              </Link>
            </li>
          ) : (
            <li className="flex items-center" key={i}>
              <a
                href="#"
                aria-current="page"
                className="cursor-text text-12 text-gray-7C7C7C ps-4 hover:!text-gray-7C7C7C"
              >
                {el.title}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export { CustomBreadCrump };
